// extracted by mini-css-extract-plugin
export var container = "styles-module__container___nxSjX";
export var checkbox = "styles-module__checkbox___mrHAv";